import { quotationStatusStyle } from "../../utils/constants/quotationStatus";

export const QuotationStatusBadge = ({ status }) => {
  if (!status) return <span className="text-gray-500">—</span>;
  return (
    <span
      className={`inline-block text-[10px] font-semibold px-1.5 py-0.5 rounded ${
        quotationStatusStyle(status).badge
      }`}
    >
      {status}
    </span>
  );
};

export const quotationStatusRail = (status) => quotationStatusStyle(status).rail;
